import {useEffect, useState} from "react";
import {RepoInfo, Skeleton} from "../../../api/types";
import {agent} from "../../../api/agent";
import {useNavigate} from "react-router-dom";
import Button from "../../Button";
import SyncedList from "../../SyncedList";
import JobDetail from "./JobDetail";
import Loading from "../../Loading";
import ActionBar from "./ActionBar";

interface Props {
    repo: string;
}

export default function JobDetails({repo}: Props) {


    const [skeletons, setSkeletons] = useState<Skeleton[]>([]);
    const navigate = useNavigate();
    const [repoInfo, setRepoInfo] = useState<RepoInfo | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const syncedList = new SyncedList<Skeleton>();
        agent.getRepoInfo(repo).then(setRepoInfo);
        const id = agent.subscribe(`/skeleton/${encodeURIComponent(repo)}`, (value: Skeleton[]) => {
            syncedList.processData(value);

            setSkeletons(
                [...syncedList.getList()].sort((a, b) => {
                    if (a.status === "running" && b.status !== "running") return -1;
                    if (b.status === "running" && a.status !== "running") return 1;
                    return new Date(b.date).getTime() - new Date(a.date).getTime();
                })
            );
            setLoading(false);
        });
        return () => agent.unsubscribe(id);
    }, [repo]);

    return (<>
        <Loading open={loading}></Loading>
        <div style={{marginTop: '2rem'}}>
            {repoInfo && (<ActionBar repo={repoInfo} updateRepo={() => {
                agent.getRepoInfo(repo).then(setRepoInfo);
            }}></ActionBar>)}
            {skeletons.map(value => <JobDetail skeleton={value} key={value.id}></JobDetail>)}
        </div>
    </>);

}